import { defaultConversionValues } from 'modules/journey/components/JourneyConversions';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import {
  NewWorkflowDialog,
  NewWorkflowDialogResult,
} from 'modules/workflowIndex/components/NewWorkflowDialog';
import { QUERY_PARAMS } from 'modules/workflowIndex/constants';
import { useCreateNewJourney } from 'modules/workflowIndex/hooks/useCreateNewJourney';
import { useRootFolderId } from 'modules/workflowIndex/hooks/useRootFolderId';
import { createDraftWorkflow } from 'modules/workflowIndex/utils/createDraftWorkflow';
import { getIsJourneyLabelsEnabled } from 'modules/workflows/ducks';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RumComponentContextProvider } from 'services/observability/datadog';
import { Product, Team } from 'teams';
import {
  serializationOptionsForNumberValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

export const CreateWorkflowModal = () => {
  const { closeMenu } = useQuickActionsMenuContext();
  const ROOT_FOLDER_ID = useRootFolderId();
  const dispatch = useDispatch();
  const isJourneyLabelsEnabled = useSelector(getIsJourneyLabelsEnabled);
  const isStartTileRefreshEnabled = true;

  /**
   * folderId search param may be present, if user is on Workflow Index -- if so, it should be used.
   * Otherwise Root Folder ID will be used.
   */
  const [folderIdSearchParam] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.FOLDER_ID,
    stateValueWhenSearchParamIsUnset: ROOT_FOLDER_ID,
    ...serializationOptionsForNumberValue,
  });

  const createNewJourney = useCreateNewJourney();

  const handleCreationConfirmation = useCallback(
    ({
      name,
      conversions = [defaultConversionValues],
      description,
      labels,
    }: NewWorkflowDialogResult) => {
      closeMenu();
      if (isJourneyLabelsEnabled) {
        createNewJourney({
          name,
          description,
          destinationFolderId: folderIdSearchParam,
          conversions,
          labels,
        });
      } else {
        createDraftWorkflow(
          name,
          description,
          folderIdSearchParam,
          conversions,
          dispatch,
          isStartTileRefreshEnabled,
        );
      }
    },
    [closeMenu, folderIdSearchParam],
  );

  return (
    <RumComponentContextProvider
      componentName="QuickActions/CreateTemplateModal"
      productName={Product.TEMPLATE_INDEX}
      teamName={Team.CAMPAIGN_TEAM}
    >
      <NewWorkflowDialog onClose={closeMenu} onConfirm={handleCreationConfirmation} />
    </RumComponentContextProvider>
  );
};
